(function () {
  'use strict';
  /* =========================================================
     BAESOLE REFINE — additive presentation behaviour only.
     - Mobile collection filters presented as a bottom sheet
       (scroll-lock + scrim). The existing filtering LOGIC in
       baesole-collection.js is untouched: this file never
       filters, navigates or changes the form; it only manages
       the sheet chrome (scroll-lock, scrim, a header/close).
     - Mobile nav: collapsible nested child links.
     Loaded LAST from the footer group. Uses event delegation,
     so it survives collection re-renders.
     ========================================================= */
  if (window.__baeRefineJS) return;
  window.__baeRefineJS = true;

  var mqSheet = window.matchMedia('(max-width:749px)');
  var scrim = null;

  function filtersForm() { return document.querySelector('[data-bae-filters]'); }
  function collRoot() { return document.querySelector('[data-bae-collection]'); }

  function sheetEngage() {
    if (!mqSheet.matches) return;
    var f = filtersForm();
    if (!f || f.hidden) return;
    document.body.style.overflow = 'hidden';
    if (!f.querySelector('.bae-filtersheet__head')) {
      var head = document.createElement('div');
      head.className = 'bae-filtersheet__head';
      head.innerHTML = '<strong>Filters</strong>' +
        '<button type="button" class="bae-filtersheet__close" aria-label="Sluiten" data-bae-filters-close>&times;</button>';
      f.insertBefore(head, f.firstChild);
    }
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'bae-coll__filterscrim';
      document.body.appendChild(scrim);
      scrim.addEventListener('click', function () {
        var ff = filtersForm();
        if (ff) ff.hidden = true;
        sheetDisengage();
      });
    }
  }

  function sheetDisengage() {
    document.body.style.overflow = '';
    if (scrim) { scrim.remove(); scrim = null; }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-bae-filters-open]')) {
      /* let baesole-collection.js flip the form first, then dress it */
      setTimeout(sheetEngage, 0);
    } else if (e.target.closest('[data-bae-filters-close]')) {
      setTimeout(sheetDisengage, 0);
    }
  });

  var cr = collRoot();
  if (cr && window.MutationObserver) {
    /* a filter change re-renders the collection root → sheet is gone → clean up */
    new MutationObserver(function () { if (scrim) sheetDisengage(); }).observe(cr, { childList: true });
  }
  if (mqSheet.addEventListener) {
    mqSheet.addEventListener('change', function () { if (!mqSheet.matches) sheetDisengage(); });
  }

  /* ---------- Mobile nav: collapsible nested children ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var acc = e.target.closest('[data-bae-acc]');
    if (!acc) return;
    e.preventDefault();
    var open = acc.getAttribute('aria-expanded') === 'true';
    acc.setAttribute('aria-expanded', String(!open));
    var li = acc.closest('li');
    var sub = li ? li.querySelector('[data-bae-sub]') : null;
    if (sub) sub.hidden = open;
  });
})();
